module.exports = __webpack_public_path__ + "static/media/change-direction-btn.c64da12b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bus-eireann/change-direction-btn.svg
// module id = 228
// module chunks = 0